// Solution Studio — routing shell (mounted in AwsApp at /solution-studio/*).
//
// Follows the SitApp / AgentStudioApp routing-shell pattern. Orange (AWS) theme. The three lifecycle
// tabs (Design / Build / Test) live inside ProjectWorkspace; this shell only routes between the
// library, a project workspace, and the full-screen diagram editor (§3).

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import ProjectLibrary from './ProjectLibrary';
import ProjectWorkspace from './ProjectWorkspace';
import DiagramEditor from './DiagramEditor';

function SolnStudioApp() {
  return (
    <Routes>
      <Route path="" element={<ProjectLibrary />} />
      <Route path=":id" element={<ProjectWorkspace />} />
      <Route path=":id/diagram/:flowId" element={<DiagramEditor />} />
      <Route path="*" element={<Navigate to="" replace />} />
    </Routes>
  );
}

export default SolnStudioApp;
